import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var IPhoneHomeButton = function IPhoneHomeButton(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99658 20.5049C4.99658 22.207 6.18604 23.3452 7.97021 23.3452H16.0708C17.8242 23.3452 18.9932 22.207 18.9932 20.5049V3.67822C18.9932 1.97607 17.8242 0.837891 16.0708 0.837891H7.97021C6.18604 0.837891 4.99658 1.97607 4.99658 3.67822V20.5049ZM9.9082 2.84766C9.9082 2.58105 10.0928 2.40674 10.3491 2.40674H13.6509C13.9072 2.40674 14.0918 2.58105 14.0918 2.84766C14.0918 3.11426 13.9072 3.28857 13.6509 3.28857H10.3491C10.0928 3.28857 9.9082 3.11426 9.9082 2.84766ZM7.04736 19.4487V4.73438H16.9424V19.4487H7.04736ZM12.0103 22.1968C11.4771 22.1968 11.0464 21.7661 11.0464 21.2329C11.0464 20.71 11.4771 20.2896 12.0103 20.2896C12.5332 20.2896 12.9536 20.71 12.9536 21.2329C12.9536 21.7661 12.5332 22.1968 12.0103 22.1968Z"
  })));
};

IPhoneHomeButton.displayName = 'IPhoneHomeButton';
export default IPhoneHomeButton;